import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { validate, renderField } from "./PasswordValidationSchema";

import Button from "./../Elements/Button.js";

class ResetPasswordForm extends Component {
  render() {
    const { handleSubmit, submitting, error, valid } = this.props;

    return (
      <form onSubmit={handleSubmit} className="login-form" autoComplete="off">
        <h2 className="font-weight-bold">Create new password.</h2>

        <div className="form-msg-1 mt-4 mb-5">
          You must create a new password in order to continue.
        </div>

        {error && error !== "success" ? (
          <div className="alert alert-danger">
            {error === "invalid_token" ? "Your token has expired." : error}
          </div>
        ) : null}
        {error && error === "success" ? (
          <div className="alert alert-success">
            Password was changed successfully!
          </div>
        ) : null}

        <div className="form-group">
          <Field
            name="password"
            type="password"
            className="form-control form-control-lg"
            placeholder="password"
            component={renderField}
          />
        </div>

        <div className="form-group pt-3">
          <Field
            name="password2"
            type="password"
            className="form-control form-control-lg"
            placeholder="confirm password"
            component={renderField}
          />
        </div>

        <div className="form-msg-3">
          Passwords must be at least 8 characters and must contain a combination
          of letters, numerals, capital letters, and a special character such as
          #!()*&%$.
        </div>

        <div className="form-group d-flex justify-content-end align-items-baseline">
          <Button
            color="primary"
            float="right"
            className="btn btn-lg mt-3 btn-submit"
            disabled={submitting || !valid}
            onClick={handleSubmit}
          >
            SUBMIT
          </Button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "reset_password",
  validate
})(ResetPasswordForm);
